import React, { useEffect, useState } from 'react';
import MaterialTable, { MTableFilterRow } from 'material-table';
import EventDataService from '../../../../services/EventService';
import { useTranslation } from 'react-i18next';
import { getAppTimezone } from '../../../../utils/timezone';

const WorkingNowTable = () => {
    const { t } = useTranslation();
    const [events, setEvent] = useState([]);

    const [loc] = React.useState(() => {
        const locData = localStorage.getItem('loc');
        return locData ? JSON.parse(locData).id : '';
    });

    useEffect(() => {
        retrieveEvents();
    }, []);

    const retrieveEvents = async () => {
        const locData = JSON.parse(localStorage.getItem('loc'));

        try {
            let response;

            if (Array.isArray(locData)) {
                const joinedValues = locData.join(',');
                response = await EventDataService.getAllNow(joinedValues);
            } else if (locData.id === 'all') {
                response = await EventDataService.adminAllNow();
            }

            if (response) {
                setEvent(response.data);
                console.log(response.data);
            }
        } catch (e) {
            console.log(e);
        }
    };

    const [open, setOpen] = React.useState(false);
    const handleClickOpen = () => {
        setOpen(true);
    };

    const SPACED_DATE_FORMAT = 'DD/MMM/YYYY H:MM:ss';

    // * Add Filters to State Start
    const [selectedRows, setSelectedRows] = useState([]);

    const [components] = useState({
        FilterRow: props => <MTableFilterRow {...props} />,
    });

    const [columns] = useState([
        // {
        //     title: 'Магазин',
        //     field: 'location',
        //     editable: 'never',
        //     defaultSort: 'asc',
        // },
        { title: t('home.employeeID'), field: 'sap', editable: 'never' },
        {
            title: t('home.employeeName'),
            field: 'name',
            editable: 'never',
            defaultSort: 'asc',
        },
        {
            title: t('home.deviceLocation'),
            field: 'location',
            editable: 'never',
        },
        {
            title: t('home.department'),
            field: 'sub_loc_name',
            editable: 'never',
        },
        {
            title: t('home.deviceName'),
            field: 'device_name',
            editable: 'never',
        },
        {
            title: t('home.enterTime'),
            field: 'time',
            editable: 'never',
            render: rowData => {
                // Format the date in Bulgarian format, in the configured app tz
                if (rowData.time) {
                    const date = new Date(rowData.time);
                    return date.toLocaleString('bg-BG', {
                        day: '2-digit',
                        month: '2-digit',
                        year: 'numeric',
                        hour: '2-digit',
                        minute: '2-digit',
                        second: '2-digit',
                        timeZone: getAppTimezone(),
                    });
                }
                return '';
            },
        },
    ]);
    // * Add Filters to State End

    return (
        <div>
            <MaterialTable
                columns={columns}
                data={events}
                style={{
                    borderRadius: '0',
                    boxShadow: 'none',
                }}
                actions={[
                    {
                        icon: 'refresh',
                        tooltip: 'Refresh',
                        isFreeAction: true,
                        onClick: retrieveEvents,
                    },
                ]}
                options={{
                    loadingType: 'linear',
                    maxBodyHeight: '40vh',
                    pageSize: 100,
                    showTitle: true,
                    sorting: true,
                    actionsColumnIndex: -1,
                    exportButton: { csv: true, pdf: false },
                    filtering: true,
                    pageSizeOptions: [20, 50, 100, 200, 300, 400, 500],
                    toolbar: false,
                }}
                components={components}
                onSelectionChange={rows => {
                    setSelectedRows(rows);
                }}
                localization={{
                    pagination: {
                        labelDisplayedRows:
                            '{from}-{to} ' +
                            t('reports.common.of') +
                            ' {count}',
                        labelRowsPerPage: t('reports.common.rowsPerPage'),
                        labelRowsSelect: t('reports.common.rowsSelect'),
                    },
                    body: {
                        emptyDataSourceMessage: t(
                            'reports.common.emptyDataSourceMessage'
                        ),
                        filterRow: {
                            filterTooltip: t('reports.common.filter'),
                        },
                    },
                }}
            />
        </div>
    );
};

export default WorkingNowTable;
